import { useState } from 'react';

// components
import {
  Card,
  CardActions,
  CardContent,
  Collapse,
  IconButton,
  IconButtonProps,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  styled,
} from '@mui/material';

// data
import dataTitle from './dataTitle';

// icons
import { BiMinus } from 'react-icons/bi';
import { RiAddFill } from 'react-icons/ri';
import { formatNumber } from 'utils/formatHelper';
import { CardItemProp } from './CardItem';
import { Style } from './styles';

// mở rộng, thu nhỏ tab
interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const ComponentInfo = (props: CardItemProp) => {
  const [expanded, setExpanded] = useState(true);
  const column = dataTitle.componentColumns;

  // ======================FUNCTION ====================================
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      <Card className={props.className}>
        <CardActions disableSpacing className="bg-primary !p-1">
          <Typography className="!text-default text-white !ml-3">{props.title}</Typography>
          <ExpandMore expand={expanded} onClick={handleExpandClick} aria-expanded={expanded} aria-label="show more">
            {expanded ? (
              <BiMinus className="!text-white !text-base" />
            ) : (
              <RiAddFill className="!text-white !text-base" />
            )}
          </ExpandMore>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent className="border rounded-b border-primary !pb-3">
            <div className={`overflow-x-auto my-1`}>
              {/* =========== Table Work Order ===============*/}
              <div className={`overflow-x-auto`}>
                <TableContainer
                  component={Paper}
                  className="w-full table-auto overflow-y-hidden space-collapse mb-1 text-default"
                >
                  <Table className="w-full" aria-label="simple table" sx={Style.borderInherit}>
                    <TableHead className="font-medium text-gray-700  text-default bg-gray-100">
                      <TableRow>
                        {column.map((item, index) => {
                          if (item.visible) {
                            return (
                              <TableCell
                                key={index}
                                sx={[Style.MuiTableCellRoot]}
                                scope="col"
                                align={`${item.align === 'text-center' ? 'center' : 'inherit'}`}
                                className={`${item.visible ? '' : 'hidden'}
                                  ${item.width}
                                  py-2 px-2 border  bg-primary/80 ${item.align}`}
                              >
                                {item.columnName}
                              </TableCell>
                            );
                          }
                          return null;
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {props.data.length ? (
                        props?.data?.map((row, index) => {
                          return (
                            <TableRow
                              className={`${index % 2 !== 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-gray-100`}
                              key={index}
                            >
                              {/* Thứ tự */}
                              <TableCell
                                sx={[Style.MuiTableCellRootTd]}
                                className="border whitespace-nowrap !text-center"
                              >
                                {index + 1}
                              </TableCell>
                              {/* Mã NVL */}
                              <TableCell sx={[Style.MuiTableCellRootTd]} className="border whitespace-nowrap">
                                {row.component}
                              </TableCell>
                              {/* Tên NVL */}
                              <TableCell sx={[Style.MuiTableCellRootTd]} className="border whitespace-nowrap">
                                {row.description}
                              </TableCell>
                              {/* Số lượng*/}
                              <TableCell
                                sx={[Style.MuiTableCellRootTd]}
                                className="border whitespace-nowrap !text-right"
                              >
                                {formatNumber(row.quantity, 3)}
                              </TableCell>
                              {/* ĐVT */}
                              <TableCell sx={[Style.MuiTableCellRootTd]} className="border whitespace-nowrap">
                                {row.unit}
                              </TableCell>
                              {/* Mã Marquette */}
                              <TableCell sx={[Style.MuiTableCellRootTd]} className="border whitespace-nowrap">
                                {row.marquetteCode}
                              </TableCell>
                              {/* Khổ nguyên (mm) */}
                              <TableCell sx={[Style.MuiTableCellRootTd]} className="border whitespace-nowrap">
                                {row.size}
                              </TableCell>
                              {/* Khổ in (mm) */}
                              <TableCell sx={[Style.MuiTableCellRootTd]} className="border whitespace-nowrap">
                                {row.sizePrint}
                              </TableCell>
                              {/* SL tờ in (tờ cắt) (được xả từ tờ nguyên) */}
                              <TableCell
                                sx={[Style.MuiTableCellRootTd]}
                                className="border whitespace-nowrap  !text-right"
                              >
                                {formatNumber(row.quantityPaperCut, 0)}
                              </TableCell>
                              {/* SL tờ in (tờ cắt) cần đạt tối thiểu */}
                              <TableCell
                                sx={[Style.MuiTableCellRootTd]}
                                className="border whitespace-nowrap  !text-right"
                              >
                                {formatNumber(row.quantityPaperCutMin, 0)}
                              </TableCell>
                              {/* Thông số màu */}
                              <TableCell sx={[Style.MuiTableCellRootTd]} className="border whitespace-nowrap">
                                {row.colorParam}
                              </TableCell>
                              {/* Mã màu pha */}
                              <TableCell sx={[Style.MuiTableCellRootTd]} className="border whitespace-nowrap">
                                {row.colorCode}
                              </TableCell>
                              {/* Quy cách in */}
                              <TableCell sx={[Style.MuiTableCellRootTd]} className="border whitespace-nowrap">
                                {row.printSpecifications}
                              </TableCell>
                              {/* Khổ kẽm */}
                              <TableCell sx={[Style.MuiTableCellRootTd]} className="border whitespace-nowrap">
                                {row.zincSize}
                              </TableCell>
                              {/* Số kẽm */}
                              <TableCell
                                sx={[Style.MuiTableCellRootTd]}
                                className="border whitespace-nowrap !text-right"
                              >
                                {formatNumber(Number(row.zincNumber), 0)}
                              </TableCell>
                              {/* Ghi chú */}
                              <TableCell sx={[Style.MuiTableCellRootTd]} className="border whitespace-nowrap">
                                {row.note}
                              </TableCell>
                              {/* Gia công ngoài */}
                              <TableCell sx={[Style.MuiTableCellRootTd]} className="border whitespace-nowrap">
                                {row.outResource}
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={column.length + 1}
                            sx={[Style.MuiTableCellRootTd]}
                            className="px-2 border whitespace-nowrap !text-center"
                          >
                            Không tìm thấy
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </CardContent>
        </Collapse>
      </Card>
    </>
  );
};

export default ComponentInfo;
